export const AUTH_BASIC = 'feetr45XX:qwkop098CCs'
export const API_ROOT = 'https://api2022.naleycards.com'
export const PAYPAL = {
 client : {
   sandbox : 'AS-XnpDd2srF_QTyI-gY70Etd1kI6B8q24r7kEIiTKildZTMERHtmAD4sNDtWXnh1_qqLrjr4pgS8zxo',
   production : 'AW6GnYoTnxZ11uYRdG2QUPxaueq8wpimUqU4qCufA0JUIxtm1xPat4vqR99FliLXBuUj7qt6eZ2gvPwe',
 },
 environment : 'production',
 business : 'boonkit@gmail.com',
 formAction: 'https://www.paypal.com/cgi-bin/webscr',
 callback : 'https://api2022.naleycards.com/paypalcallback',
}
export const IPAY = {
 formAction : 'https://payment.ipay88.com.my/epayment/entry.asp',
 merchantCode : 'M15511',
 merchantKey : 'VdnjRS1znt',
 responseUrl : 'https://api2022.naleycards.com/ipaycallback',
 backendUrl : 'https://api2022.naleycards.com/ipaycallback/backend',
}
